import api from './axios';

export interface AssistantTurn {
  role: 'user' | 'assistant';
  content: string;
}

export interface AssistantRequest {
  question: string;
  locale?: 'fr' | 'ar';
  /** Prior conversation turns, oldest first, so follow-up questions keep context. */
  history?: AssistantTurn[];
}

export interface AssistantResponse {
  answer: string;
  provider: string;
  model: string;
  latencyMs: number;
}

export const assistantApi = {
  /** Multi-turn Q&A against the TuniFact dashboard assistant. The backend
   *  injects the dashboard snapshot into the prompt; the client sends the
   *  question plus prior turns so follow-ups keep context. See backend
   *  DashboardAssistantController + spec 09. */
  ask: async (req: AssistantRequest): Promise<AssistantResponse> => {
    const { data } = await api.post<AssistantResponse>('/dashboard/assistant', req);
    return data;
  },
};
